<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- <j-title-header :options="title"/> -->
    <div class="component-card-report m__t--50">
      <label class="label-report">Total Lulusan</label>
      <j-bar-chart-js
        v-if="showReportTotalLulusan"
        :datacollection="datacollectionLulusan"
        :options="optionsLulusan" />

      <v-client-table
        :data="data_table"
        :columns="columns"
        :options="options"
        class="jTable" />
        <!-- <jLoadingTable v-if="!load_first"/> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKurikulum from '@/services/jApiKurikulum';
// import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    // jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Report Pegawai',
      },
      load_first: false,
      data_table: [],
      columns: ['tahun_lulusan', 'jumlah_lulusan', 'bekerja', 'kuliah', 'wirausaha', 'belum_ketahui'],
      options: {
        headings: {
          tahun_lulusan: 'Tahun Lulusan',
          jumlah_lulusan: 'Jumlah Lulusan',
          bekerja: 'Bekerja',
          kuliah: 'Kuliah',
          wirausaha: 'Wirausaha',
          belum_ketahui: 'Belum Ketahui',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [10, 50, 100],
      },

      showReportTotalLulusan: false,
      datacollectionLulusan: {
        labels: [],
        datasets: [],
      },
      optionsLulusan: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.totalLulusan();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    async totalLulusan() {
      const getList = await jApiKurikulum.getTotalLulusan();
      const values = Object.values(getList.data.data);
      const keys = Object.keys(getList.data.data);
      this.datacollectionLulusan.labels = Object.keys(getList.data.data);
      this.datacollectionLulusan.datasets = [
        {
          label: 'Bekerja',
          backgroundColor: '#1392ff',
          data: values.map(el => el.bekerja),
        },
        {
          label: 'Belum Ketahui',
          backgroundColor: '#f87979',
          data: values.map(el => el.belum_ketahui),
        },
        {
          label: 'Kuliah',
          backgroundColor: '#06CD00',
          data: values.map(el => el.kuliah),
        },
        {
          label: 'Wirausaha',
          backgroundColor: '#CD00CA',
          data: values.map(el => el.wirausaha),
        },
      ];
      this.showReportTotalLulusan = true;

      keys.forEach((e, index) => {
        this.data_table.push({
          tahun_lulusan: e,
          jumlah_lulusan: values[index].total,
          bekerja: values[index].bekerja,
          kuliah: values[index].kuliah,
          wirausaha: values[index].wirausaha,
          belum_ketahui: values[index].belum_ketahui,
        });
      });
    },
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/bimbingan-konseling/lulusan/jLulusanReport.vue